import { PackageLinksApiResponse } from './PackageLinksPage.types';
import { useFetchApi } from '../../../fetchApi.hook';
import { useStateKey } from '../../../hooks/useStateKey.hook';
import { LendingApiErrorResponse } from '../../../utils/LendingApiError';

export function usePackageLinks({
  includeDeleted = false,
}: {
  includeDeleted?: boolean;
} = {}) {
  const { stateKey } = useStateKey();

  const { payload: packageLinksApiData, triggerFetch: fetchPackageLinks } =
    useFetchApi<PackageLinksApiResponse | LendingApiErrorResponse>({
      endpoint: `/api/lending/edge/iwocapay/pay_link_package/${stateKey}/`,
    });

  let packageLinks =
    (isLendingApiResponseSuccess(packageLinksApiData) &&
      packageLinksApiData.data) ||
    [];
  if (!includeDeleted) {
    packageLinks = packageLinks.filter(
      (packageLink) => !packageLink.deleted_at,
    );
  }

  return {
    packageLinks: packageLinks,
    fetchPackageLinks,
  };
}

function isLendingApiResponseSuccess<T extends { data: unknown }>(
  apiData: T | LendingApiErrorResponse | undefined,
): apiData is T {
  return (apiData as T)?.data !== undefined;
}
